import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="p-2 md:p-2 shadow-lg custom-header bg-gray-100 text-black">
      <div className="container mx-auto flex items-center justify-between">
        {/* Left side: DANE, Geoportal and title */}
        <div className="flex items-center space-x-2 md:space-x-3 flex-1 min-w-0">
          <img
            src="/LogoDANE_Nuevo.svg"
            alt="DANE"
            className="h-6 md:h-8 w-auto flex-shrink-0"
          />
          <img
            src="/assets/images/geoportal.png"
            alt="Geoportal"
            className="h-6 md:h-8 w-auto flex-shrink-0"
          />
          <h1 className="text-xs md:text-lg font-bold text-black ml-2 md:ml-4 truncate">
            <span className="hidden sm:inline">Geovisor de Centros de Cuidados Públicos en Colombia</span>
            <span className="sm:hidden">Geovisor de Cuidados Colombia</span>
          </h1>
        </div>
        
        {/* Right side: Igualdad logo */}
        <div className="flex items-center flex-shrink-0 mr-2 md:mr-4">
          <img
            src="/logo_minigualdad.svg"
            alt="Minigualdad"
            className="h-8 md:h-10 w-auto"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
